import { AgGridAngular } from 'ag-grid-angular';
import { ColDef, ColGroupDef } from 'ag-grid-community';
import { Component, OnInit , ViewChild} from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { UserserviceService } from '../userservice.service';
import { ViewApplicationDetailsComponent } from '../view-application-details/view-application-details.component';

@Component({
  selector: 'app-add-board-user',
  templateUrl: './add-board-user.component.html',
  styleUrls: ['./add-board-user.component.scss']
})
export class AddBoardUserComponent implements OnInit {

  allboarduserdata!:any; 
  addboarduser!: FormGroup;
  submitted!:boolean;
  selectedid: any;
  frmdisable:boolean=false;
  currMode="View";
  actiontaken="Create";
  showtable: boolean=true;
  updateuser: boolean=false;
  rowData:any;
  pagination:any;
  proccessing:boolean=false;
  curruserid: any;
  constructor(private formBuilder: FormBuilder,private service:UserserviceService,private route: ActivatedRoute, public router:Router) { }
      public columnDefs: (ColDef | ColGroupDef)[] = [
        {headerName: 'user Id',field: 'board_coordinator_id', width: 140, sortable: true, filter: true },
        {headerName: 'User\'s Name',field: 'full_name', width: 300, sortable: true, filter: true },
        {headerName: 'Mobile No',field:'mobile_no', width: 140, sortable:true, filter:true},
        {headerName: 'Email Address',field:'email_address', width: 280,sortable:true,filter:true},
        {headerName: 'Status',field:'board_cord_status',width: 140, sortable: true, filter: true}, 
        // {headerName: 'View',
        //       field: 'application_id',
        //       width: 85,
        //       cellRenderer : function(params: any){
        //         return '<div> <button class="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#extraInfo"(click)="viewuser(t.teacher_id)" >View</button> </div>'
        //       },
        // },
        {headerName: 'View',
          field: 'board_coordinator_id',
          width: 90,
          cellRenderer:ViewApplicationDetailsComponent,
          cellRendererParams: {
          clicked: (field: any) => {            
            // return '<div> <button class="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#extraInfo"(click)="viewuser(t.teacher_id)" >View</button> </div>'
            this.openmodal("extraInfo");
            this.viewuser(field);
          }
        },
    }
        // <td class="text-center"><button class="btn btn-success btn-sm" data-bs-toggle="modal" data-bs-target="#extraInfo"(click)="viewuser(t.teacher_id)" >View</button></td>
        ];
        
    public defaultColDef: ColDef = {
      // set the default column width
      width: 145,
      // make every column editable
      // editable: true,
      // make every column use 'text' filter by default
      filter: 'agTextColumnFilter',
      // enable floating filters by default
      
      // make columns resizable
      resizable: true,
    };
  ngOnInit(): void {
    //authentication
    if(!sessionStorage.getItem("loggeduser") || sessionStorage.getItem("loggeduser")==null){
      this.router.navigate(['/boardadminlogin']);
      // sessionStorage.clear();
      }
      else  if(sessionStorage.getItem('roleid')!="2"){
      this.router.navigate(['/dashboard']);
      }
     //datatables settings
    
    this.addboarduser = this.formBuilder.group({   
      full_name: ['', Validators.required],
      mobile_no :['',[Validators.required, Validators.pattern("^((\\+91-?)|0)?[0-9]{10}$")]],
      email_address:['',[Validators.required,Validators.email,Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]],
      address:['',Validators.required],
      board_cord_status:['']
    });
    this.getAllboarduser();
  }
  getAllboarduser(){
    this.service.post('/Boardadmin_module/fetch_all_board_user',{}).subscribe((res:any)=>{
      // console.log(res);
      if(res.status=="success"){
        this.allboarduserdata=res.Data;
        this.rowData=[res.Data]; 
              this.allboarduserdata=res.Data; 
              this.pagination=true;
      }
      else{
        this.rowData=[];
        this.showtable=false;
      }
	});	
  }
  get f() { return this.addboarduser.controls; }

  getboarduserData(frm:any){
    this.submitted = true;
    if (this.addboarduser.invalid) {
      alert("Please fill all details!!")
      return;
    }
    if(this.updateuser==false){
        this.addnewboarduser();  
    }
    else{
        this.updateboarduserdetails();
    }
  }

  createmodeon(){
    this.addboarduser.reset();
    this.frmdisable=false;
    this.selectedid="";
    this.actiontaken="Create";
    this.updateuser=false;
  }

  viewuser(uid:any){
    this.frmdisable=true;
    this.selectedid=uid;
    this.actiontaken="View";
    this.updateuser=true;
    this.curruserid=uid;
    this.getboarduserDetails(uid);
  }
  toggleViewEdit(){
    this.frmdisable=!this.frmdisable;
    if(this.frmdisable==true){
      this.currMode="View Mode";
      this.actiontaken="View";
      this.updateuser=true;
    }
    else{
       this.currMode="Edit Mode";
       this.actiontaken="Edit";
       this.updateuser=true;
    }
  }
  openmodal(mdl:any){
    let testmodal=document.getElementById(mdl);
    testmodal?.style.setProperty("display","block");
    testmodal?.classList.add("show");
  }
  closemodal(mdl:any){
    let testmodal=document.getElementById(mdl);
    testmodal?.style.setProperty("display","none");
  }
  addnewboarduser(){
    let c = confirm("Are You sure You want to create Board User ?");
    if(c==true){
        this.proccessing=true;
        let studdetail = new FormData;
          studdetail.append('full_name',this.addboarduser.value.full_name); 
          studdetail.append('mobile_no',this.addboarduser.value.mobile_no);
          studdetail.append('email_address',this.addboarduser.value.email_address); 
          studdetail.append('address',this.addboarduser.value.address);
          studdetail.append('board_cord_status',this.addboarduser.value.board_cord_status);
        
        this.service.post('/Boardadmin_module/add_new_board_user',studdetail).subscribe((res:any)=>{
          console.log(res);
          setTimeout(()=>{
                if(res.status=="success"){
                    console.log(res.Data);
                      alert(res.Data+"\r\n ");        
                    window.location.reload();
                }
                else{
                  alert(res.Data)
                }
                this.proccessing=false;
          },1000);    
      
      });
    }
  }
  getboarduserDetails(uid:any){
      // console.log(this.allboarduserdata);
      for(let i=0;i<this.allboarduserdata.length;i++){
        if(this.allboarduserdata[i].board_coordinator_id==uid){
          this.addboarduser.controls['full_name'].setValue(this.allboarduserdata[i].full_name);
          this.addboarduser.controls['mobile_no'].setValue(this.allboarduserdata[i].mobile_no);
          this.addboarduser.controls['email_address'].setValue(this.allboarduserdata[i].email_address);
          this.addboarduser.controls['address'].setValue(this.allboarduserdata[i].address);
          this.addboarduser.controls['board_cord_status'].setValue(this.allboarduserdata[i].board_cord_status);
        }
      }
     
  }
  updateboarduserdetails(){
    let c = confirm("Are You sure You want to make changes in \nBoard User No"+this.curruserid+"\nUser Name: "+this.addboarduser.value.full_name);
    if(c==true){
          this.proccessing=true;
          let studdetail = new FormData;
            
            studdetail.append('user_id',this.curruserid); 
            studdetail.append('full_name',this.addboarduser.value.full_name); 
            studdetail.append('mobile_no',this.addboarduser.value.mobile_no);
            // studdetail.append('email_address',this.addboarduser.value.email_address); 
            studdetail.append('address',this.addboarduser.value.address);
            studdetail.append('board_cord_status',this.addboarduser.value.board_cord_status);
          this.service.post('/Boardadmin_module/update_board_user',studdetail).subscribe((res:any)=>{
            console.log(res);
            setTimeout(()=>{
                  if(res.status=="success"){
                      console.log(res.Data);
                        alert(res.Data+"\r\n ");        
                      window.location.reload();
                  }
                  else{
                    alert(res.Data)
                  }
                  this.proccessing=false;
            },1000);    
        
        });
    }
  }
}
